import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;

  .SpendLimitTile-kv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${spacing(4)};
  }

  .SpendLimitTile-kvLabel {
    display: inline-flex;
    align-items: center;
    gap: ${spacing(2)};
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextPrimary};
  }

  .SpendLimitTile-kvValue {
    font-family: ${font_family_weight_medium};
    ${font_lg};
    color: ${text_colorTextPrimary};
    font-variant-numeric: tabular-nums;
  }

  .SpendLimitTile-divider {
    height: 1px;
    width: 100%;
    border: none;
    background-color: ${base_colorContentBorder};
    margin: ${spacing(4)} 0 0;
  }

  /* Matches .SettingsDisclosure-title (e.g. "Billing address") so section
     headings across the tiles read at the same size. Rubik faces are all
     registered at font-weight: normal, so the browser's default
     <h4> { font-weight: bold } would layer a synthetic bold on top of
     Rubik-Medium — pin it to normal and let the family carry the weight. */
  .SpendLimitTile-heading {
    margin: ${spacing(5)} 0 ${spacing(1)};
    font-family: ${font_family_weight_medium};
    font-weight: normal;
    ${font_md};
    letter-spacing: -0.005em;
    color: ${text_colorTextPrimary};
  }

  .SpendLimitTile-body {
    margin: 0 0 ${spacing(4)};
    max-width: 58ch;
    font-family: ${font_family_weight_regular};
    ${font_md};
    line-height: 21px;
    color: ${text_colorTextSecondary};
  }

  .SpendLimitTile-form {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    max-width: 460px;
  }

  .SpendLimitTile-form .SettingsSegmented {
    align-self: flex-start;
  }

  .SpendLimitTile-dates {
    display: flex;
    gap: ${spacing(3)};
  }

  .SpendLimitTile-dates > * {
    flex: 1;
  }

  .SpendLimitTile-confirmation {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing(2)};
    padding: ${spacing(4)};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${spacing(2)};
    background-color: ${base_colorSurfaceSecondary};
    max-width: 460px;
  }

  .SpendLimitTile-confirmationHeading {
    display: inline-flex;
    align-items: center;
    gap: ${spacing(2)};
    font-family: ${font_family_weight_medium};
    ${font_md};
    color: ${text_colorTextPrimary};
  }

  .SpendLimitTile-confirmationBody {
    margin: 0;
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextSecondary};
  }
`
